<template>
  <transition name="fade-scale">
    <div class="ui-open-app" v-show="openAppOptions.show" @click.self="handleClose">
      <div class="content">
        <div class="icon icon-logo"></div>
        <span class="tips">{{ openAppOptions.tips }}</span>
        <nf-button @click="handleOpenApp" width="5.4rem">打开南方+</nf-button>
        <div class="icon icon-close" @click="handleClose"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import NfButton from "../NfButton"
import openApp from "@/utils/openApp"
import { mapGetters, mapMutations } from "vuex"
import { buryingPoint_downloadApp } from "../../server/buryingPoint"

export default {
  name: "uiOpenApp",
  methods: {
    ...mapMutations({
      closeOpenApp: "closeOpenApp"
    }),
    handleClose() {
      this.closeOpenApp()
    },
    handleOpenApp() {
      const address = `${window.location.origin}${window.location.pathname}?id=${this.activityId}`
      buryingPoint_downloadApp({})
      openApp({ address })
    }
  },
  components: {
    NfButton
  },
  computed: {
    ...mapGetters({
      openAppOptions: "openAppOptions",
      activityId: "activityInfo/activityId"
    })
  },
  mounted() {
    // document.body.appendChild(this.$mount().$el)
  }
}
</script>

<style lang="scss" scoped>
.ui-open-app {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  .content {
    width: 6.4rem;
    height: 4.56rem;
    border-radius: 0.2rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform-origin: 50% 50%;
    padding: 0.4rem 0;
    position: relative;
    .icon-logo {
      padding: 0.4rem 0;
      width: 1.8rem;
      height: 1.8rem;
      background: url("../../assets/images/pop_icon_nfapp.png") no-repeat center;
      background-size: 100%;
      margin-bottom: 0.24rem;
    }
    .tips {
      font-family: PingFang-SC-Bold;
      font-size: 0.3rem;
      color: #333333;
      margin-bottom: 0.42rem;
    }
    .icon-close {
      width: 0.8rem;
      height: 0.8rem;
      position: absolute;
      bottom: -1.2rem;
      left: 50%;
      transform: translateX(-50%);
      background: url("../../assets/images/icon_delete@2x.png") no-repeat center;
      background-size: 80%;
    }
    .btn-wrapper {
      width: 5.4rem;
    }
  }
}
.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
}
.fade-scale-enter {
  .content {
    transform: scale(1.2);
  }
}
.fade-scale-leave,
.fade-scale-enter-to {
  opacity: 1;
}
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s ease-in-out;
  .content {
    transition: all 0.3s ease-in-out;
  }
}
</style>
